<script setup lang="ts">
import { computed } from 'vue';

// PROPS
const { fields } = defineProps({
    label: { type: String, default: '' },
    fields: { type: Array as PropType<Array<BooleanRouteParamsKey>>, default: () => [] },
});

// COMPOSABLES
const { tt } = useTypedI18n();

const sellingMethod = useSlpSellingMethod();
const slpParams = useSlpParams(sellingMethod);

// DATA
const model = computed({
    get: () => fields.filter(field => !!slpParams[field].value),
    set: value => {
        fields.map(field => {
            const booleanValue = !!value.find(value => value === field);

            if (slpParams[field].value !== booleanValue) {
                slpParams[field].value = booleanValue;
            }
        });
    },
});
const items = computed(() =>
    fields.map(field => ({
        label: tt(`slp.filters.${field}`),
        value: field,
    }))
);
</script>

<template>
    <UFormField :label="label">
        <UInputMenu v-model="model" :placeholder="tt('slp.filters.inputPlaceholder')" multiple :items="items" value-key="value" />
    </UFormField>
</template>
